import React from 'react';

const LoadingPersonal = () => {
    return (
      <div className='bg-gray-50 rounded-lg mx-5 py-5'>
        <div className="px-5 py-5 flex justify-between items-center border-2 border-gray-200">
          <div className="lg:w-56 sm:w-full h-[32px] animate-pulse rounded-sm bg-gray-100 "></div>
        </div>
       <div className='grid lg:grid-cols-3 place-items-center gap-5 mt-5 p-5'>
        {Array.from({ length: 7 }).map((_, index) => (
          <div className="w-full h-[32px] animate-pulse rounded-sm bg-gray-100 p-4" key={index}></div>
        ))}
      </div>
       <div className='grid sm:grid-cols-2 place-items-start gap-3 mt-10'>
        {Array.from({ length: 2 }).map((_, index) => (
          <div className="lg:w-28 sm:w-full h-[32px] animate-pulse rounded-sm bg-gray-100 p-4" key={index}></div>
        ))}
      </div>
      </div>
    );
};

export default LoadingPersonal;